const formatRoomsRequest = (staterooms) => {
  const request = {};
  staterooms.forEach((st, index) => {
    request[`rooms[${index}].adults`] = st.adults;
    request[`rooms[${index}].seniors`] = st.seniors;
    request[`rooms[${index}].children`] = st.children && Object.values(st.children);
    request[`rooms[${index}].lapInfants`] = st.lapInfants;
    request[`rooms[${index}].seatInfants`] = st.seatInfants;
  });
  return request;
};

export default formatRoomsRequest;
